<div class="container-fluid">
    <div class="row">
        <div class="col-12 py-4 bg-white" [ngClass]="{'col-md-3': step === 0}">
            <form>
                <div class="form-group" *ngIf="step === 0">
                    <mat-form-field class="w-100 mb-3" appearance="outline">
                        <mat-label>Nombre/Idea</mat-label>
                        <input matInput type="text" required class="w-100" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="course.Title" (keyup)="generateSlug($event); checkButtonState()" aria-describedby="addon-wrapping">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                        <mat-label>Categoría</mat-label>
                        <select matNativeControl [(ngModel)]="course.Category" [ngModelOptions]="{standalone: true}"
                            (change)="selectCategory($event)">
                            <option value="">Selecciona</option>
                            <option *ngFor="let category of categories" [value]="category.id">{{category.ValueAlpha}}
                            </option>
                        </select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                        <mat-label>Nivel</mat-label>
                        <select matNativeControl [(ngModel)]="course.Level" [ngModelOptions]="{standalone: true}"
                            (change)="selectLevel($event)">
                            <option value="">Selecciona</option>
                            <option *ngFor="let level of levels" [value]="level.id">{{level.ValueAlpha}}
                            </option>
                        </select>
                    </mat-form-field>
                    <mat-form-field class="w-100 mb-3" appearance="outline">
                        <mat-label>Precio</mat-label>
                        <input matInput type="number" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="course.UnitPrice" (change)="checkButtonState()" aria-describedby="addon-wrapping">
                    </mat-form-field>
                    <mat-form-field class="w-100 mb-3" appearance="outline">
                        <mat-label>Descripción</mat-label>
                        <textarea matInput [(ngModel)]="course.Description" [ngModelOptions]="{standalone: true}"
                                  (keyup)="checkButtonState()" maxlength="400" aria-describedby="addon-wrapping">
                        </textarea>
                        <mat-hint align="end">{{ course.Description?.length || 0 }}/400</mat-hint>
                    </mat-form-field>                    
                    <mat-form-field required class="w-100 mb-3" appearance="outline">
                        <mat-label>¿Qué aprenderás?</mat-label>
                        <mat-chip-grid #chipGrid>
                            @for (learn of learning; track learn) {
                            <mat-chip-row (removed)="remove(learn)" [editable]="true"
                                [aria-description]="'press enter to edit ' + learn.name">
                                {{learn.name}}
                                <button matChipRemove [attr.aria-label]="'remove ' + learn.name">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                            }
                            <input placeholder="¿Qué aprenderás?" [matChipInputFor]="chipGrid"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                                (matChipInputTokenEnd)="add($event)" />
                        </mat-chip-grid>

                    </mat-form-field>

                    <mat-form-field required class="w-100 mb-3" appearance="outline">
                        <mat-label>¿A quién va dirigido?</mat-label>
                        <mat-chip-grid #chipGrid2>
                            @for (learn of target; track learn) {
                            <mat-chip-row (removed)="removeTarget(learn)" [editable]="true"
                                [aria-description]="'press enter to edit ' + learn.name">
                                {{learn.name}}
                                <button matChipRemove [attr.aria-label]="'remove ' + learn.name">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                            }
                            <input placeholder="¿A quién va dirigido?" [matChipInputFor]="chipGrid2"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                                (matChipInputTokenEnd)="addTarget($event)" />
                        </mat-chip-grid>

                    </mat-form-field>

                  
                    <div class="col-12">
                        <label>Imagen profesional</label>
                      
                        <!-- Si hay una imagen guardada y no se ha subido una nueva, mostrar la imagen existente -->
                        <div *ngIf="course.ImgFileUrl && !newImageSelected" class="existing-image-preview">
                          <img [src]="course.ImgFileUrl" alt="Imagen guardada" style="max-width: 100%; height: auto;"/>
                          <button mat-button class="btn btn-sm btn-primary" style="margin-top: 10px;" (click)="removeExistingImage()">Cambiar imagen</button>
                        </div>
                      
                        <!-- Mostrar el dropzone solo si no hay imagen guardada o si se seleccionó una nueva -->
                        <ngx-dropzone *ngIf="!course.ImgFileUrl || newImageSelected" (change)="onSelectImages($event)" [multiple]="false">
                            <ngx-dropzone-label class="label-file">Arrastra una imagen aquí o haz clic para seleccionar una imagen.</ngx-dropzone-label>
                          
                            <!-- Previsualización de la nueva imagen seleccionada -->
                            <ngx-dropzone-image-preview *ngFor="let f of imagesX" [file]="f" [removable]="true" (removed)="removeImage(f)">
                              <ngx-dropzone-label>{{ f.name.substr(1, 10) }}... / ({{ f.type }})</ngx-dropzone-label>
                            </ngx-dropzone-image-preview>
                        </ngx-dropzone>                          
                      
                        <!-- Mostrar el link de la imagen cargada si ya se subió -->
                        <section *ngIf="responseImgFile" style="margin-top: 10px;">
                          <a [href]="responseImgFile" target="_blank" style="color:#33bd38">Imagen cargada <i class="fa fa-check" aria-hidden="true"></i></a>
                        </section>
                      </div>                      

                    
                </div>
                <div class="container" *ngIf="step === 1">
                    <mat-drawer-container class="example-container" [hasBackdrop]="hasBackdrop.value">
                        <mat-drawer #drawer [mode]="mode.value">I'm a drawer</mat-drawer>
                        <mat-drawer-content>
                            <mat-form-field>
                                <mat-label>Sidenav mode</mat-label>
                                <mat-select #mode value="side">
                                    <mat-option value="side">Side</mat-option>
                                    <mat-option value="over">Over</mat-option>
                                    <mat-option value="push">Push</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Has backdrop</mat-label>
                                <mat-select #hasBackdrop>
                                    <mat-option>Unset</mat-option>
                                    <mat-option [value]="true">True</mat-option>
                                    <mat-option [value]="false">False</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button mat-raised-button (click)="drawer.toggle()">Toggle drawer</button>
                        </mat-drawer-content>
                    </mat-drawer-container>
                </div>
            </form>
        </div>
        <div class="col-12 col-md-9" *ngIf="step === 0">
            <div class="bg-white">
                <div class="browser-window w-100">
                    <div class="browser-header">
                        <div class="buttons">
                            <span class="button close"></span>
                            <span class="button minimize"></span>
                            <span class="button maximize"></span>
                        </div>
                        <div class="address-bar">
                            <input type="text" disabled [value]="course.Slug" readonly>
                        </div>
                    </div>
                    <div class="browser-content">
                        <div class="row">
                            <div class=" col-12 col-md-7">
                                <div class="course-detalis-wrapper mb-30">
                                    <div class="course-title-breadcrumb text-dark">
                                        <nav>
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item-front"><a href="/">Inicio</a></li>
                                                <li class="breadcrumb-item-front"><span>{{ course.Title }}</span></li>
                                            </ol>
                                        </nav>
                                    </div>
                                    <div class="course-heading mb-20">
                                        <h2>{{course.Title}}</h2>
                                    </div>
                                    <div class="course-detelis-meta" style="text-align: center;">
                                        <div class="course-meta-wrapper border-line-meta">
                                            <div class="course-meta-img">
                                                <a>
                                                    <img style="object-fit: cover;" 
                                                         *ngIf="currentUser?.imgProfile"
                                                         [src]="currentUser?.imgProfile" 
                                                         (error)="handleProfileImageError($event)"
                                                         alt="Foto de perfil">
                                                    <img style="object-fit: cover;" 
                                                         *ngIf="!currentUser?.imgProfile"
                                                         src="assets/images/user.png"
                                                         alt="Foto de perfil por defecto">
                                                </a>
                                            </div>
                                            <div class="course-meta-text">
                                                <span>Creado Por</span>
                                                <h6><b>{{ currentUser?.displayName }}</b></h6>
                                            </div>
                                        </div>
                                        <div class="course-update border-line-meta">
                                            <p>Categoría</p>
                                            <b>{{ categorySelected?.ValueAlpha }}</b>
                                        </div>
                                        <div class="course-category">
                                            <p>Nivel</p>
                                            <b>{{ levelSelected?.ValueAlpha }}</b>
                                        </div>
                                    </div>
                                    <div class="course-description pt-4 pb-3">
                                        <div class="course-Description">
                                            <h4>Descripción</h4>
                                        </div>
                                        <p [innerHTML]="course.Description"></p>
                                    </div>
                                    <div class="course-learn-wrapper">
                                        <div class="course-learn">
                                            <div class="course-leranm-tittle">
                                                <h4 class="mb-8"><b>¿Qué Aprenderás?</b></h4>
                                            </div>
                                            <div class="row">
                                                <div class="col-xl-12">
                                                    <div>
                                                        <ul>
                                                            @for (learn of learning; track learn) {
                                                            <li>
                                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                                {{ learn.name }}
                                                            </li>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="course-requirements pt-5">
                                        <h4 class="title-4"><b>¿A quién va dirigido?</b></h4>
                                        <div class="course-requirements-text">
                                            <ul>
                                                @for (learn of target; track learn) {
                                                <li>
                                                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                                    {{ learn.name }}
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                  <!-- ==================== PLAN DE ESTUDIO RESUMIDO ==================== -->
                    <div class="plan-estudio-simple mb-4">
                        <div class="card border-left-primary">
                            <div class="card-header bg-light">
                                <h5 class="mb-0 text-primary">
                                    <i class="fa fa-graduation-cap mr-2"></i>
                                    Plan de Estudio
                                </h5>
                            </div>
                            <div class="card-body">
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <div class="study-stats">
                                            <span class="badge badge-info mr-2">
                                                <i class="fa fa-layer-group mr-1"></i>
                                                {{ getModulosCount() }} Módulos
                                            </span>
                                            <span class="badge badge-success">
                                                <i class="fa fa-clock mr-1"></i>
                                                {{ getLeccionesCount() }} Lecciones
                                            </span>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                                <!-- Acordeones de módulos -->
                                <div class="modules-accordion">
                                    <cdk-accordion class="study-plan-accordion">
                                        <cdk-accordion-item 
                                            *ngFor="let modulo of getModulos(); let i = index"
                                            #accordionModule="cdkAccordionItem"
                                            class="module-accordion-item">
                                            
                                            <!-- Header del módulo -->
                                            <div class="module-header" 
                                                 role="button"
                                                 tabindex="0"
                                                 [class.active]="accordionModule.expanded"
                                                 (click)="accordionModule.toggle()"
                                                 (keydown.enter)="accordionModule.toggle()"
                                                 (keydown.space)="accordionModule.toggle()">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="module-info">
                                                        <span class="module-number">{{ i + 1 }}.</span>
                                                        <span class="module-name">{{ modulo.Name }}</span>
                                                        <span class="lesson-count text-muted ml-2">({{ modulo.Topics?.length || 0 }} lecciones)</span>
                                                    </div>
                                                    <div class="module-controls d-flex align-items-center">
                                                        <div class="module-status mr-2">
                                                            <i *ngIf="isModuleCompleted(modulo)" class="fa fa-check-circle text-success"></i>
                                                            <i *ngIf="!isModuleCompleted(modulo)" class="fa fa-circle text-muted"></i>
                                                        </div>
                                                        <i class="fa fa-chevron-down accordion-icon" 
                                                           [class.rotated]="accordionModule.expanded"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <!-- Contenido del módulo (lecciones) -->
                                            <div class="module-content" 
                                                 role="region"
                                                 [style.display]="accordionModule.expanded ? 'block' : 'none'">
                                                <div class="lessons-list">
                                                    <div *ngFor="let lesson of modulo.Topics; let j = index" 
                                                         class="lesson-item">
                                                        <div class="d-flex justify-content-between align-items-center">
                                                            <div class="lesson-info">
                                                                <span class="lesson-number">{{ j + 1 }}.</span>
                                                                <span class="lesson-title">{{ lesson.Title || 'Lección sin título' }}</span>
                                                            </div>
                                                            <div class="lesson-status">
                                                                <i *ngIf="lesson.uploaded" class="fa fa-check-circle text-success"></i>
                                                                <i *ngIf="!lesson.uploaded" class="fa fa-circle text-muted"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <!-- Mensaje si no hay lecciones -->
                                                    <div *ngIf="!modulo.Topics || modulo.Topics.length === 0" 
                                                         class="no-lessons text-muted text-center py-2">
                                                        <i class="fa fa-info-circle mr-1"></i>
                                                        No hay lecciones creadas aún
                                                    </div>
                                                </div>
                                            </div>
                                        </cdk-accordion-item>
                                    </cdk-accordion>
                                    
                                    <!-- Mensaje si no hay módulos -->
                                    <div *ngIf="!getModulos() || getModulos().length === 0" 
                                         class="no-modules text-center py-4">
                                        <i class="fa fa-graduation-cap fa-2x text-muted mb-2"></i>
                                        <p class="text-muted mb-0">No hay módulos creados aún</p>
                                        <small class="text-muted">Los módulos aparecerán aquí una vez que los crees</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                            </div>
                            <div class="col-12 col-md-5">
                                <div class="course-video-widget">
                                    <div class="course-widget-wrapper mb-30">
                                        <div class="course-video-thumb w-img">
                                            <!-- Usar método getImagePreview() para obtener la imagen -->
                                            <img alt="Portada del curso" 
                                                 *ngIf="!getImagePreview()"
                                                 src="assets/images/placeholder.png">
                                            <img alt="Portada del curso" 
                                                 *ngIf="getImagePreview()"
                                                 [src]="getImagePreview()"
                                                 (error)="handleImageError($event)">
                                        </div>
                                        <div class="course-video-price">
                                            <div class="event-price-info">
                                                <div class="event-ticket-cost"><span>Precio:</span></div>
                                                <div class="event-price"><span>${{ course.UnitPrice | number: '1.2-2' }}
                                                        MXN</span>
                                                    <div class="old-price"><!----></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="course-video-body">
                                            <ul>
                                                <li>
                                                    <div class="course-vide-icon"><i
                                                            class="flaticon-filter"></i><span>Nivel</span></div>
                                                    <div class="video-corse-info"><span>{{ levelSelected?.ValueAlpha
                                                            }}</span></div>
                                                </li>
                                                <li>
                                                    <div class="course-vide-icon"><i
                                                            class="flaticon-menu-2"></i><span>Categoría</span></div>
                                                    <div class="video-corse-info"><span>{{ categorySelected?.ValueAlpha
                                                            }}</span></div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>